import { FC, PropsWithChildren } from 'react';
import { SxProps, Box } from '@mui/material';

type AdaptiveContentProps = PropsWithChildren & {
	sx?: SxProps;
};

const AdaptiveContent: FC<AdaptiveContentProps> = ({ sx, children }) => {
	return (
		<Box
			sx={{
				'@media screen and (min-width: 1441px)': {
					width: '65%',
				},
				...sx,
			}}
		>
			{children}
		</Box>
	);
};

export default AdaptiveContent;
